//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

export type RejectionCode = Opaque<number, 'RejectionCode'>;

function RejectionCodeFactory(rejectionCode: number) {
  return rejectionCode as RejectionCode;
}

export const RejectionCode = RejectionCodeFactory;
